// I think I'll want to store either the sheet, or sheet id.
class CarnivoreSheetEvents {
  initialized = false;
}

export default CarnivoreSheetEvents;
